import "@fontsource/rubik";
import "@fontsource/karla";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Buffer } from "buffer";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { SessionTimeoutProvider } from "app/providers/session-timeout-provider";
import { persistor, store } from "app/store";
import theme from "app/theme/chakra.theme";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import Loading from "views/components/loading";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
(window as any).Buffer = Buffer;
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <Provider store={store}>
      <BrowserRouter>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <ChakraProvider theme={theme}>
            <SessionTimeoutProvider>
              <App />
              <Toaster />
            </SessionTimeoutProvider>
          </ChakraProvider>
        </PersistGate>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
